import * as dompurify from 'dompurify';
const purifier = dompurify['default'] as dompurify.DOMPurify;

export class StringFns {
  static isNullEmptyOrWhiteSpace(s: string | null) {
    return s === null || s === undefined || s.match(/^ *$/) !== null;
  }

  static tagsrx = /<.*?>/g;

  /** Remove HTML tags from the string */
  static stripHtmlTags(s: string) {
    if (!s) { return s; }
    // TODO replace <br> with \n, &lt; with <, etc.
    return s.replace(this.tagsrx, '');
  }

  static filerx = /[ .:;,<>"|?*#%&{}+~\\/]/g;

  /** Remove spaces and invalid filename characters from the string, replace with '-' */
  static stripInvalidFilenameChars(s: string) {
    if (!s) { return s; }
    s = s.replace(this.filerx, '-');
    s = s.replace(/-+/g, '-');
    return s;
  }

  /** Sanitize HTML string using DOMPurify.  Removes css, javascript, unknown tags, etc. */
  static purify(s: string, cfg?: dompurify.Config) {
    return purifier.sanitize(s, cfg) as string;
  }

  /** Sanitize HTML while preserving Handlebars tokens ({{...}}, {{{...}}}).
   *  Replaces tokens with safe placeholders before purifying, then restores them. */
  static purifyWithHandlebars(s: string) {
    const tokens: string[] = [];
    // Match triple braces first, then double braces (including block helpers like {{#if}}, {{/if}})
    const protected_ = s.replace(/\{\{\{.+?\}\}\}|\{\{.+?\}\}/g, (match) => {
      tokens.push(match);
      return `__HBS_${tokens.length - 1}__`;
    });
    let result = purifier.sanitize(protected_) as string;
    tokens.forEach((token, i) => {
      result = result.replace(`__HBS_${i}__`, token);
    });
    return result;
  }
}